import {
  createDeleteType,
  createErrorType,
  createFetchType,
  createLoadingType,
  createSubmitType,
  createSuccessType,
  createUpdateType,
} from '../actionHelpers';

const PRICE_ALERTS_SCOPE = 'PRICE_ALERTS_SCOPE';
export const PRICE_ALERTS_FETCH = createFetchType(PRICE_ALERTS_SCOPE);
export const PRICE_ALERTS_SUCCESS = createSuccessType(PRICE_ALERTS_SCOPE);
export const PRICE_ALERTS_ERROR = createErrorType(PRICE_ALERTS_SCOPE);
export const PRICE_ALERTS_LOADING = createLoadingType(PRICE_ALERTS_SCOPE);

const PRICE_ALERT_SCOPE = 'PRICE_ALERT';
export const PRICE_ALERT_FETCH = createFetchType(PRICE_ALERT_SCOPE);
export const PRICE_ALERT_SUCCESS = createSuccessType(PRICE_ALERT_SCOPE);
export const PRICE_ALERT_ERROR = createErrorType(PRICE_ALERT_SCOPE);
export const PRICE_ALERT_LOADING = createLoadingType(PRICE_ALERT_SCOPE);

const PATCH_PRICE_ALERTS_SCOPE = 'PATCH_PRICE_ALERTS';
export const PATCH_PRICE_ALERTS = createUpdateType(PATCH_PRICE_ALERTS_SCOPE);
export const PATCH_PRICE_ALERTS_SUCCESS = createSuccessType(
  PATCH_PRICE_ALERTS_SCOPE,
);
export const PATCH_PRICE_ALERTS_ERROR = createErrorType(
  PATCH_PRICE_ALERTS_SCOPE,
);

const PATCH_PRICE_ALERT_SCOPE = 'PATCH_PRICE_ALERT';
export const PATCH_PRICE_ALERT = createUpdateType(PATCH_PRICE_ALERT_SCOPE);
export const PATCH_PRICE_ALERT_SUCCESS = createSuccessType(
  PATCH_PRICE_ALERT_SCOPE,
);
export const PATCH_PRICE_ALERT_ERROR = createErrorType(PATCH_PRICE_ALERT_SCOPE);

const DELETE_PRICE_ALERT_SCOPE = 'DELETE_PRICE_ALERT';
export const DELETE_PRICE_ALERT = createDeleteType(DELETE_PRICE_ALERT_SCOPE);
export const DELETE_PRICE_ALERT_SUCCESS = createSuccessType(
  DELETE_PRICE_ALERT_SCOPE,
);
export const DELETE_PRICE_ALERT_ERROR = createErrorType(
  DELETE_PRICE_ALERT_SCOPE,
);

const DISMISS_PRICE_ALERT_BADGE_SCOPE = 'DISMISS_PRICE_ALERT_BADGE';
export const DISMISS_PRICE_ALERT_BADGE = createSubmitType(
  DISMISS_PRICE_ALERT_BADGE_SCOPE,
);

const DISMISS_PRICE_ALERT_BANNER_SCOPE = 'DISMISS_PRICE_ALERT_BANNER';
export const DISMISS_PRICE_ALERT_BANNER = createSubmitType(
  DISMISS_PRICE_ALERT_BANNER_SCOPE,
);

const POST_PRICE_ALERT_SCOPE = 'POST_PRICE_ALERT';
export const POST_PRICE_ALERT = createSubmitType(POST_PRICE_ALERT_SCOPE);
export const POST_PRICE_ALERT_SUCCESS = createSuccessType(
  POST_PRICE_ALERT_SCOPE,
);
export const POST_PRICE_ALERT_ERROR = createErrorType(POST_PRICE_ALERT_SCOPE);

const SETUP_MOCK_PRICE_ALERTS_SCOPE = 'SETUP_MOCK_PRICE_ALERTS';
export const SETUP_MOCK_PRICE_ALERTS = createSubmitType(
  SETUP_MOCK_PRICE_ALERTS_SCOPE,
);

const CLEAR_EXPIRED_PRICE_ALERTS_SCOPE = 'CLEAR_EXPIRED_PRICE_ALERTS';
export const CLEAR_EXPIRED_PRICE_ALERTS = createSubmitType(
  CLEAR_EXPIRED_PRICE_ALERTS_SCOPE,
);
export const CLEAR_EXPIRED_PRICE_ALERTS_SUCCESS = createSuccessType(
  CLEAR_EXPIRED_PRICE_ALERTS_SCOPE,
);
export const CLEAR_EXPIRED_PRICE_ALERTS_ERROR = createErrorType(
  CLEAR_EXPIRED_PRICE_ALERTS_SCOPE,
);
